import type { OverviewActivityItem } from '../../lib/dashboard/overview/buildOverviewActivity';
import { overviewToneColor } from '../../lib/dashboard/overview/buildOverviewStatus';

type ActivityFeedProps = {
  items: OverviewActivityItem[];
  emptyMessage: string;
};

export function ActivityFeed({ items, emptyMessage }: ActivityFeedProps) {
  return (
    <section
      className="w-full overflow-hidden rounded-[14px] border"
      style={{ background: 'var(--gs-panel)', borderColor: 'var(--gs-line)' }}
    >
      {items.length === 0 ? (
        <div className="px-5 py-[22px] text-sm" style={{ color: 'var(--gs-muted)' }}>
          {emptyMessage}
        </div>
      ) : (
        items.map((item) => (
          <div
            key={item.id}
            className="flex items-center gap-3.5 border-b px-5 py-3.5 last:border-b-0"
            style={{ borderColor: 'var(--gs-line)' }}
          >
            <span
              className="h-2 w-2 shrink-0 rounded-full"
              style={{ background: overviewToneColor(item.tone) }}
              aria-hidden
            />
            <span className="min-w-0 flex-1 text-[14.5px]" style={{ color: 'var(--gs-ink)' }}>
              {item.text}
            </span>
            <span className="shrink-0 text-[12.5px]" style={{ color: 'var(--gs-muted)' }}>
              {item.timeLabel}
            </span>
          </div>
        ))
      )}
    </section>
  );
}
